import { magento } from "@magento/clients/getClient";

export type PrepareProductLinkOptions = {
  shopUrl: string;
  pdpUrl: string;
};

const pdpMappingCache: Record<string, string> = {};

export async function prepareProductLink(sku: string, { shopUrl, pdpUrl }: PrepareProductLinkOptions): Promise<string> {
  if (!sku) {
    return "";
  }

  if (pdpMappingCache[sku]) {
    return pdpMappingCache[sku];
  }

  let response: Awaited<ReturnType<typeof magento.getUrlKeys>>;
  try {
    response = await magento.getUrlKeys(sku);
  } catch {
    return "";
  }

  const product = response?.products?.items?.[0];
  if (!product) {
    return "";
  }

  const productUrlKey = product.url_key;

  const category = product.categories?.[0];
  if (!category) {
    return "";
  }

  const baseURL = pdpUrl || shopUrl;

  const categoryUrlKey = category?.url_path;
  const productLink = `${baseURL}/${categoryUrlKey}/${productUrlKey}`;
  pdpMappingCache[sku] = productLink;
  return productLink;
}
